module.exports = __webpack_public_path__ + "static/media/reebok.b26ff280.svg";